
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ReceiptGrid extends _Ext.GridBase<ReceiptRow, any> {
        protected getColumnsKey() { return 'Finance.Receipt'; }
        protected getDialogType() { return ReceiptDialog; }
        protected getIdProperty() { return ReceiptRow.idProperty; }
        protected getInsertPermission() { return ReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptRow.localTextPrefix; }
        protected getService() { return ReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();

            var voucherNo= FormatHelper.GetVoucherNo(5);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<ReceiptRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                CreatedBy: userDefinition.UserId,
                VoucherTypeId: 5,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId,
                ExchangeRate: userDefinition.exchangerate,
                CurrencyId: userDefinition.CurrencyId,
                EnteredBy: userDefinition.UserId,
                UserId: userDefinition.UserId
            });
        }
    }
}